import { useState, useCallback } from 'react';


// this hook is used to manage API errors and add them properly in the antd form fields.

export function useApiFormError(form) {
  const [apiErrors, setApiErrors] = useState({});

  // for getting error message from API

  const setApiError = useCallback((field, message) => {
    form.setFields([{ name: field, errors: [message] }]);
    setApiErrors((prev) => ({ ...prev, [field]: message }));
  }, [form]);

  // function to clear the error message

  const clearApiError = useCallback((field) => {
    if (apiErrors[field]) {
      form.setFields([{ name: field, errors: [] }]);
      setApiErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
  }, [apiErrors, form]);

  // custom validator function to be added in the antd form field

  const customApiValidator = useCallback((rule, value) => {
    if (apiErrors[rule.field]) {
      return Promise.reject(apiErrors[rule.field]);
    }
    return Promise.resolve();
  }, [apiErrors]);

  // function to check for api error in the given field.
  // mainly useful for disabling other form field validaitions if the api errror is present thus giving primary focus to the api error.
  
  const hasApiError = useCallback((field) => {
    return apiErrors[field];
  }, [apiErrors]);

  return {
    setApiError,
    clearApiError,
    hasApiError,
    customApiValidator
  };
}
